// src/api_scripts/get/getOutdialAnis.js
import { fetchAllPages } from "../paginationUtils";

const getOutdialAnis = async (unused, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/outdial-ani`;

  try {
    // Use the pagination utility to fetch all pages
    const outdialAnisArray = await fetchAllPages(relativeUri, accessToken, setProgress, "OutDial ANIs", 1000);
    console.log("Get OutDial ANIs API Response Data (all pages):", outdialAnisArray.length, "items");
    return outdialAnisArray;

  } catch (error) {
    // If it's a 404, the API endpoint doesn't exist in this environment
    if (error.message && (error.message.includes('404') || error.message.includes('Request failed with status code 404'))) {
      console.warn(`OutDial ANIs API endpoint not available (404). This is expected in some environments.`);
      if (setProgress) {
        setProgress((prev) => [
          ...prev,
          { type: 'warning', message: 'OutDial ANIs API not available in this environment (404) - skipping', timestamp: new Date().toLocaleTimeString() }
        ]);
      }
      return []; // Return empty array instead of throwing error
    }

    console.error(`Error fetching OutDial ANIs:`, error);
    throw error; // Re-throw other errors
  }
};

export default getOutdialAnis;